import { Badge, Table, Pagination, Flex } from "@mantine/core";
import dayjs from "dayjs";
import React from "react";

import { User } from "types";
import { PaginationData } from "api/organizations/getOrg";

import ActionsBtn from "./ActionsBtn";
import styles from "./OrgMembersTable.module.css";

type OrgMembersTableProps = {
  members: User<string>[];
  user: User;
  orgId: string;
  pagination?: PaginationData;
  onPageChange?: (page: number) => void;
  currentPage?: number;
};

function OrgMembersTable({
  members,
  user,
  orgId,
  pagination,
  onPageChange,
  currentPage = 1,
}: OrgMembersTableProps) {
  console.log("Membersemail----------------------->:", members);
  return (
    <div className={styles.container}>
      <Table
        withBorder
        // className={styles.table}
        verticalSpacing="sm"
        highlightOnHover
        // horizontalSpacing={20}
      >
        <thead
          style={{
            backgroundColor: "#f5f5f5",
          }}
        >
          <tr>
            <th className={styles.action}>&nbsp;</th>
            <th>NAME</th>
            <th>Corporate Email</th>
            <th>DEPARTMENT</th>
            <th>PROGRAM</th>
            <th>POSITION</th>
            <th>ROLE</th>
            <th>MEMBER SINCE</th>
          </tr>
        </thead>
        <tbody>
          {members.map((member) => (
            <tr key={member._id}>
              <td>
                {member._id !== user._id && (
                  <ActionsBtn member={member} orgId={orgId} />
                )}
              </td>
              <td style={{ fontSize: "13px" }}>
                {`${member.firstName} ${member.lastName}`}
              </td>
              <td style={{ fontSize: "13px" }}>{member.email}</td>
              <td style={{ fontSize: "13px" }}>
                {member.department?.name ? member.department?.name : "N/A"}
              </td>
              <td style={{ fontSize: "13px" }}>
                {(member as any).program?.name ? (member as any).program?.name : "N/A"}
              </td>
              <td style={{ fontSize: "13px" }}>{member.position}</td>
              <td style={{ fontSize: "13px" }}>
                <Badge color="violet.7" size="sm">
                  {member.role}
                </Badge>
              </td>
              <td style={{ fontSize: "13px" }}>
                {dayjs(member.createdAt).isValid()
                  ? dayjs(member.createdAt).format("DD MMM YYYY")
                  : "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {pagination && onPageChange && (
        <Flex justify="center" style={{ marginTop: "20px" }}>
          <Pagination
            page={currentPage}
            onChange={onPageChange}
            total={pagination.pages}
            withEdges
          />
        </Flex>
      )}
    </div>
  );
}

export default OrgMembersTable;
